import type { SyncDownloadProgress } from '@core/domain/sync/SyncPushResult.ts';

/** Parse JSON from a fetch Response while reporting streamed byte progress. */
export async function readResponseJsonWithProgress(
  response: Response,
  onProgress?: (progress: SyncDownloadProgress) => void,
): Promise<unknown> {
  const totalHeader = response.headers.get('Content-Length');
  const parsedTotal = totalHeader ? Number.parseInt(totalHeader, 10) : Number.NaN;
  const total = Number.isFinite(parsedTotal) && parsedTotal > 0 ? parsedTotal : null;
  const body = response.body;
  if (!body || !onProgress) return response.json();

  const reader = body.getReader();
  const chunks: Uint8Array[] = [];
  let loaded = 0;
  onProgress({ loaded, total });

  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    chunks.push(value);
    loaded += value.byteLength;
    onProgress({ loaded, total });
  }

  const merged = new Uint8Array(loaded);
  let offset = 0;
  for (const chunk of chunks) {
    merged.set(chunk, offset);
    offset += chunk.byteLength;
  }
  return JSON.parse(new TextDecoder().decode(merged));
}
